import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const translationVersion = Date.now(); // lub Date.now() dla dynamicznego cache bustera

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'pl-PL',
        supportedLngs: ['pl-PL', 'en-US', 'uk-UA'],

        backend: {
            loadPath: (lngs, namespaces) => `/locales/${lngs[0]}.json?v=${translationVersion}`
        },

        detection: {
            order: ['cookie', 'localStorage', 'navigator'],
            lookupCookie: 'UserCulture',
            caches: ['cookie']
        },

        react: {
            useSuspense: false
        }
    });

export default i18n;
